import {ItemType} from 'common/constants/survey';
import {Series, SurveyPage, SurveyPageItem} from 'common/models/survey';

const isSeries = (item: SurveyPageItem | SurveyPage): item is Series => {
    return (item as Series).type === ItemType.Series;
};
export default isSeries;
